// import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || 'https://xibarubamback.onrender.com',
// });

// const handleApiCall = async (apiCall) => {
//   try {
//     const response = await apiCall();
//     return response.data;
//   } catch (error) {
//     console.error('Erreur API:', error.response?.data || error.message);
//     throw error;
//   }
// };

// export const fetchArticles = async ({ page = 1, limit = 10, categorySlug = '', featured = false, sort = '' }) => {
//   const data = await handleApiCall(() =>
//     api.get('/articles', {
//       params: { page, limit, categorySlug, featured, sort },
//     })
//   );

//   return {
//     articles: data.articles,
//     totalPages: data.totalPages,
//   };
// };

// export const incrementArticleViews = async (articleId) => {
//   try {
//     const viewKey = `article_${articleId}_viewed`;
//     const lastViewed = localStorage.getItem(viewKey);
//     const now = Date.now();
    
//     if (lastViewed && (now - parseInt(lastViewed)) < 3600000) {
//       return { success: false, reason: 'recently_viewed' };
//     }
    
//     await handleApiCall(() => 
//       api.post(`/articles/${articleId}/increment-view`)
//     );
    
//     localStorage.setItem(viewKey, now.toString());
    
//     return { success: true };
//   } catch (error) {
//     return { success: false, reason: 'api_error', error };
//   }
// };

// export const fetchCategories = async () => {
//   const data = await handleApiCall(() => api.get('/categories'));
//   return data; 
// };

// export const fetchComments = async (postId, page = 1, perPage = 10) => {
//   return await handleApiCall(() =>
//     api.get(`/comments/article/${postId}`, {
//       params: { page, perPage },
//     })
//   );
// };

// export const fetchArticleBySlug = async (slug) => {
//   try {
//     const { data } = await api.get(`/articles/${slug}`);
//     return data;
//   } catch (error) {
//     console.error('Error fetching article:', error.response?.data || error.message);
//     throw error;
//   }
// };

// export const fetchRelatedArticles = async (articleId, categories = [], limit = 4) => {
//   const categoryIds = categories.map(cat => cat.id).join(',');
//   return await handleApiCall(() =>
//     api.get(`/articles`, {
//       params: { articleId, categoryIds, limit }
//     })
//   );
// };

// export const getCategoryBySlug = async (slug) => {
//   return await handleApiCall(() => api.get(`/categories/${slug}`));
// };

// export const getArticlesByCategory = async (categorySlug, page = 1, perPage = 10) => {
//   return await handleApiCall(() =>
//     api.get('/articles', {
//       params: { categorySlug, page, limit: perPage },
//     })
//   );
// };

// export const fetchPopularPosts = async (limit = 5) => {
//   const data = await handleApiCall(() =>
//     api.get('/articles', {
//       params: { limit, sort: 'popular' },
//     })
//   );
//   return data.articles || [];
// };

// export const submitComment = async (commentData) => {
//   return await handleApiCall(() =>
//     api.post(`/comments`, commentData)
//   );
// };

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://xibarubamback.onrender.com',
});

const handleApiCall = async (apiCall) => {
  try {
    const response = await apiCall();
    return response.data;
  } catch (error) {
    console.error('Erreur API:', error.response?.data || error.message);
    throw error;
  }
};

export const fetchArticles = async ({ page = 1, limit = 10, categorySlug = '', featured = false, sort = '' }) => {
  const data = await handleApiCall(() =>
    api.get('/articles', {
      params: { page, limit, categorySlug, featured, sort },
    })
  );

  return {
    articles: data.articles,
    totalPages: data.totalPages,
  };
};

export const incrementArticleViews = async (articleId) => {
  try {
    const viewKey = `article_${articleId}_viewed`;
    const lastViewed = localStorage.getItem(viewKey);
    const now = Date.now();

    if (lastViewed && (now - parseInt(lastViewed)) < 3600000) {
      return { success: false, reason: 'recently_viewed' };
    }

    await handleApiCall(() =>
      api.post(`/articles/${articleId}/increment-view`)
    );

    localStorage.setItem(viewKey, now.toString());

    return { success: true };
  } catch (error) {
    return { success: false, reason: 'api_error', error };
  }
};

export const fetchCategories = async () => {
  const data = await handleApiCall(() => api.get('/categories'));
  return data;
};

export const fetchComments = async (articleId) => {
  try {
    console.log('Récupération des commentaires pour l\'article:', articleId);
    
    const response = await api.get(`/comments/article/${articleId}`);
    const comments = response.data || [];
    
    console.log('Commentaires récupérés:', comments);
    
    // Mapper les données pour correspondre à votre interface React
    return comments.map(comment => ({
      id: comment.comment_ID,
      author: comment.comment_author || 'Lecteur anonyme',
      email: comment.comment_author_email,
      content: comment.comment_content,
      date: comment.comment_date,
      parentId: comment.comment_parent,
      approved: comment.comment_approved === '1',
      website: comment.comment_author_url
    }));
  } catch (error) {
    console.error('Erreur lors de la récupération des commentaires:', error);
    return []; // Retourner un tableau vide en cas d'erreur
  }
};

export const fetchArticleBySlug = async (slug) => {
  try {
    const { data } = await api.get(`/articles/${slug}`);
    return data;
  } catch (error) {
    console.error('Error fetching article:', error.response?.data || error.message);
    throw error;
  }
};

export const fetchRelatedArticles = async (articleId, categories = [], limit = 4) => {
  const categoryIds = categories.map(cat => cat.id).join(',');
  return await handleApiCall(() =>
    api.get(`/articles`, {
      params: { articleId, categoryIds, limit }
    })
  );
};

export const getCategoryBySlug = async (slug) => {
  return await handleApiCall(() => api.get(`/categories/${slug}`));
};

export const getArticlesByCategory = async (categorySlug, page = 1, perPage = 10) => {
  return await handleApiCall(() =>
    api.get('/articles', {
      params: { categorySlug, page, limit: perPage },
    })
  );
};

export const fetchPopularPosts = async (limit = 5) => {
  const data = await handleApiCall(() =>
    api.get('/articles', {
      params: { limit, sort: 'popular' },
    })
  );
  return data.articles || [];
};

// Fonction mise à jour pour soumettre un commentaire
export const submitComment = async (commentData) => {
  try {
    console.log('Soumission du commentaire:', commentData);
    
    // const payload = {
    //   comment_post_ID: commentData.postId || commentData.articleId,
    //   comment_author: commentData.author,
    //   comment_author_email: commentData.email,
    //   comment_author_url: commentData.website || '',
    //   comment_content: commentData.content,
    //   comment_parent: commentData.parentId || 0,
    // };
    const payload = {
  comment_post_ID: Number(commentData.postId || commentData.articleId),
  comment_author: commentData.author,
  comment_author_email: commentData.email,
  comment_author_url: commentData.website || '',
  comment_content: commentData.content,
  comment_parent: Number(commentData.parentId || 0),
};


    const response = await handleApiCall(() =>
      api.post('/comments', payload)
    );

    console.log('Commentaire créé:', response);
    
    // Mapper la réponse pour votre interface React
    if (response.data) {
      return {
        id: response.data.comment_ID,
        author: response.data.comment_author,
        email: response.data.comment_author_email,
        content: response.data.comment_content,
        date: response.data.comment_date,
        parentId: response.data.comment_parent,
        approved: response.data.comment_approved === '1',
        website: response.data.comment_author_url
      };
    }
    
    return response;
  } catch (error) {
    console.error('Erreur lors de la soumission du commentaire:', error);
    throw error;
  }
};


// Récupérer le nombre de commentaires d'un article
export const getCommentsCount = async (articleId) => {
  try {
    const response = await handleApiCall(() =>
      api.get(`/comments/article/${articleId}/count`)
    );
    return response;
  } catch (error) {
    console.error('Erreur lors de la récupération du nombre de commentaires:', error);
    return { count: 0 };
  }
};

// Approuver un commentaire (fonction admin)
export const approveComment = async (commentId, token) => {
  try {
    const response = await handleApiCall(() =>
      api.patch(`/comments/${commentId}/approve`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Erreur lors de l\'approbation du commentaire:', error);
    throw error;
  }
};

// Rejeter un commentaire (fonction admin)
export const rejectComment = async (commentId, token) => {
  try {
    const response = await handleApiCall(() =>
      api.patch(`/comments/${commentId}/reject`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Erreur lors du rejet du commentaire:', error);
    throw error;
  }
};

// Supprimer un commentaire
export const deleteComment = async (commentId, token) => {
  try {
    const response = await handleApiCall(() =>
      api.delete(`/comments/${commentId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Erreur lors de la suppression du commentaire:', error);
    throw error;
  }
};

// Récupérer tous les commentaires (admin)
export const fetchAllComments = async (token) => {
  try {
    const response = await handleApiCall(() =>
      api.get('/comments', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Erreur lors de la récupération de tous les commentaires:', error);
    throw error;
  }
};

// Récupérer les commentaires en attente (admin)
export const fetchPendingComments = async (token) => {
  try {
    const response = await handleApiCall(() =>
      api.get('/comments/pending', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    );
    return response;
  } catch (error) {
    console.error('Erreur lors de la récupération des commentaires en attente:', error);
    throw error;
  }
};